<template>
    <TotemToggleButton
        v-model="hideDemoContent"
        :value="hideDemoContent"
        :label="$t('ReportingFilters.hide_demo_content')"
        class="filter-select"
        :width="toggleWidth"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'SearchToggleHideDemoContent',
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                isDemoContentHidden: 'Search/isDemoContentHidden',
                currentLanguage: 'Languages/getSelectedCountryCode'
            }),
            hideDemoContent: {
                get () {
                    return this.isDemoContentHidden
                },
                set (value) {
                    this.$store.dispatch('Search/setHideDemoContentToggle', value)
                }
            },
            toggleWidth () {
                return  this.currentLanguage === 'fi' ? 304 : 285
            }
        }
    }
</script>
